import { userSettingsService } from '../services';
import * as act from '@/store/userSettings.action';

const state = {
  userSettings: null
};

const actions = {
  async [act.ACT_USERSETTINGS]({ commit }) {
    await userSettingsService.get()
      .then(result => {
        commit(act.MUT_USERSETTINGS, { userSettings: result });
      })
      .catch(_error => {});
  }
};

const getters = {
  [act.GET_USERSETTINGS]: state => {
    return state.userSettings;
  }
};

const mutations = {
  [act.MUT_USERSETTINGS](state: any, { userSettings }): void {
    state.userSettings = userSettings;
  }
};

export const userSettings = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
